export default {
  "config": {
    "trial": "tones-5",
    "id": "participant-disposition",
    "type": "design",
    "title": "Participant Disposition Including Maintenance Phase and Randomized Withdrawal Phase<sup>14</sup>",
    "footnotes": [],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-5",
    "id": "participant-disposition",
    "data-type": "design",
    "title": "Participant Disposition Including Maintenance Phase and Randomized Withdrawal Phase<sup>14</sup>",
    "footnote-tooltip": "disable"
  }
};